import { render, staticRenderFns } from "./ProblemsPanel.vue?vue&type=template&id=2cc91731&scoped=true&"
import script from "./ProblemsPanel.vue?vue&type=script&lang=js&"
export * from "./ProblemsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProblemsPanel.vue?vue&type=style&index=0&id=2cc91731&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc91731",
  null
  
)

export default component.exports